export const MAP_TONES = [
  "primary",
  "neutral",
  "success",
  "warning",
  "error",
] as const;

export const DEFAULT_TONE = "primary";

export const DEFAULT_ZOOM = 13;

export const DEFAULT_HEIGHT = "20rem";

export const DEFAULT_MAP_ID = "DEMO_MAP_ID";

export const DEFAULT_MARKER_SIZE = 32;

export const DEFAULT_ROUTE_WIDTH = 4;

export const DEFAULT_POPOVER_WIDTH = "20rem";

export const DEFAULT_POPOVER_HEIGHT = "14rem";

// Pixels kept clear around the fitted content, on every side.
export const FIT_PADDING = 48;

// Pixels kept between an open card and the edge of the map.
export const CARD_PAN_PADDING = 8;

// A single point has no extent, so fitting to it means this zoom.
export const FIT_SINGLE_ZOOM = 15;

export const GOOGLE_MAPS_LIBRARIES = ["marker"] as const;

export const HTML_DATASET_KEY = "googleMapsKey";

export const HTML_DATASET_MAP_ID = "googleMapsId";

// Where the map opens before anything is placed on it.
export const DEFAULT_CENTER = { lat: 46.8, lng: 8.2 };
